// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-container[data-v-62c97411]{flex:1;display:flex;flex-flow:column;padding-top:.5rem}.download[data-v-62c97411]{text-align:center}.order-submitted[data-v-62c97411]{display:flex;flex-direction:column;flex-grow:1;align-items:center;justify-content:center}.is-xlarge[data-v-62c97411]{width:5rem;height:5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
